import React, { CSSProperties, ReactNode } from 'react'
import cls from 'classnames'
import css from './index.module.less'

type TabProps = {
  options: { label: string; value: string; count?: number; right?: ReactNode }[]
  value: string
  onChange: (value: string) => void
  right?: ReactNode,
  style?: CSSProperties
}
export default function Tab(props: TabProps) {
  const { value, options, onChange, right, style } = props
  const current = options.find((item) => item.value === value)
  return (
    <div className={css.header} style={style}>
      <div className={css.tabs}>
        {options.map((item) => (
          <a
            key={item.value}
            onClick={() => {
              onChange(item.value)
            }}
            className={cls(css.tab, { [css.active]: value === item.value })}
          >
            {item.label} <span className={css.count}>{item.count}</span>
          </a>
        ))}
      </div>
      <div className={css.filters}>{current.right || right}</div>
    </div>
  )
}
